import { FC } from 'react'
import {
  DefaultTitle, 
  DefaultSubtitle,
  Link,
  BeforeStartInstructionsContainer,
  BeforeStartInstruction
} from '../../../components/application/defaultComponents'
import { InsuranceTypeData } from 'src/dtos/applicationData'
import ReminderCard from '../../../components/basic/ReminderCard'
import { HiOutlinePlusCircle } from 'react-icons/hi'
import { tlieSources } from 'src/constants/tlie'

interface BeforeStartProps {
  insuranceType: InsuranceTypeData;
}

const BeforeStart: FC<BeforeStartProps> = ({ insuranceType }) => {
  return (
    <>
      <DefaultTitle>Before you get started...</DefaultTitle>
      <DefaultSubtitle>
        If you have any questions while completing the application, call <span style={{ color: '#3D6666' }}>1-{tlieSources.phone}</span> <br />
        or email <Link href={`mailto:${tlieSources.infoEmail}`}>{tlieSources.infoEmail}</Link>
      </DefaultSubtitle>
      <BeforeStartInstructionsContainer>
        <ReminderCard
          icon='warning'
          title='Disclaimer'
        >
          Please note this application is for a “claims made and reported” policy that provides coverage only for claims first made and reported to TLIE during the policy period.
        </ReminderCard>
        <span>You will need the following items to complete this application.</span>
        {insuranceType === 'LAWYER' ? (
          <>
            <BeforeStartInstruction>
              <HiOutlinePlusCircle />
              The bar cards of all of the attorneys currently working for your firm
            </BeforeStartInstruction>
            <BeforeStartInstruction>
              <HiOutlinePlusCircle />
              A copy of declaration and endorsements for any current insurance policy
            </BeforeStartInstruction>
          </>
        ) : (
          <>
            <BeforeStartInstruction>
              <HiOutlinePlusCircle />
              Applicant’s bar card
            </BeforeStartInstruction>
            <BeforeStartInstruction>
              <HiOutlinePlusCircle />
              A copy of declaration and endorsements for any current insurance policy
            </BeforeStartInstruction>
          </>
        )}
      </BeforeStartInstructionsContainer>
    </>
  )
}

export default BeforeStart